document.addEventListener('DOMContentLoaded', () => {
  const POPUPS = document.querySelectorAll('.morning-popup');
  if (POPUPS.length > 0) {
    POPUPS.forEach(POPUP => {
      const morningPopup = new MorningPopup(POPUP)
      morningPopup.init()
    })
  }
})

class MorningPopup {
  constructor (POPUP) {
    this.popup = POPUP
    this.popupDelay = POPUP.dataset.initDelay ? parseInt(POPUP.dataset.initDelay) : 0
    this.openButton = POPUP.previousElementSibling
    this.overlay = POPUP.querySelector('.morning-popup__overlay')
    this.closeButton = POPUP.querySelector('.morning-popup__close-button')
  }

  init () {
    this.openButton.addEventListener('click', () => this.show())
    this.overlay.addEventListener('click', () => this.hide())
    this.closeButton.addEventListener('click', () => this.hide())
    document.addEventListener('keydown', (e) => e.key === 'Escape' && this.hide())

    if (this.popupDelay > 0 && sessionStorage.getItem('morning-popup') === null) {
      setTimeout(() => this.show(), this.popupDelay * 1000)
    }
  }

  show () {
    this.popup.classList.add('morning-popup--show')
    sessionStorage.setItem('morning-popup', 'true')
  }

  hide () {
    this.popup.classList.remove('morning-popup--show')
  }
}
